/*
 * @Author: Long
 * @Date: 2021-05-09 16:38:39
 * @LastEditors: Long
 * @LastEditTime: 2022-03-08 14:32:20
 */
const service = require('@/assets/js/request')
const env = process.env

class about {
  /**
   * 获取关于我们子栏目
   */
  static getColumnId (target) {
    service.request({
      method: 'POST',
      url: 'getColumnId',
      params: {
        id: target.id
      }
    }).then(res => {
      if (res.code === '2001') {
        if (res.data.length > 0) {
          this.getArtivleList(target, res.data[0].id)
        }
      }
    }).catch(err => {
      service.error(err, {
        that: target
      })
    })
  }

  /**
   * 获取关于我们列表
   */
  static getArtivleList (target, cateid) {
    service.request({
      method: 'POST',
      url: 'getArtivleList',
      params: {
        cate_id: cateid,
        isSpecial: 1
      }
    }).then(res => {
      if (res.code === '2001') {
        if (res.data.list.length > 0) {
          if (res.data.list[0].cover_img !== '') {
            res.data.list[0].cover_img = env.IMG_URL + res.data.list[0].cover_img
          } else {
            res.data.list[0].cover_img = '/static/defaultBg.png'
          }
          target.con = res.data.list[0]
        }
      }
    }).catch(err => {
      service.error(err, {
        that: target
      })
    })
  }
}

export default about



// WEBPACK FOOTER //
// ./src/components/index/about/about.js